module.exports = __webpack_public_path__ + "static/media/passage.cf537e39.png";